/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { alias } from '@ember/object/computed';
import { EnvironmentOption } from 'cio/pods/app/controller';

interface WorkspaceItemArgs {
  environment: EnvironmentOption;
  selected: boolean;
  onClick: () => unknown;
}

export default class WorkspaceItem extends Component<WorkspaceItemArgs> {
  @alias('args.environment.model.hexCodeWithDefault') environmentHexCode!: string;
  @alias('args.environment.model.normalDelivery') normalDelivery!: boolean;
}
